import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';
import LoadingSpinner from '../frontend/LoadingSpinner';
import { UserService } from '../utils/UserService';
import { PasswordService } from '../utils/PasswordService';
import { saveOrganization, deleteOrganization } from '../utils/OrganizationService';
import { LogoutService } from '../utils/LogoutService';

import $ from 'jquery'; // Import jQuery
import swal from 'sweetalert';

import plus_icon_black from '../../assets/frontend/images/plus_icon_black.png';
import edit_icon from '../../assets/frontend/images/edit_icon.png';
import delete_icon from '../../assets/frontend/images/delete_icon.png';
import logout_icon from '../../assets/frontend/images/logout_icon.png';

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

function Account() {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isMounted, setIsMounted] = useState(false);

    const [authRole, setAuthRole] = useState(
        AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
    );

	const [viewMode, setViewMode] = useState('view_account'); // 'view_account' | 'save_user' | 'change_password' | 'save_organization'

	const initialUserInput = {
		first_name: '',
		last_name: '',
		email: '',
		app: process.env.REACT_APP_NAME,
		errorList: [],
		errorStyle: [],
	};
	const [userInput, setUserInput] = useState(initialUserInput);

	const initialPasswordInput = {
		email: '',
		password: '',
		new_password: '',
		app: process.env.REACT_APP_NAME,
		errorList: [],
		errorStyle: [],
	};
	const [passwordInput, setPasswordInput] = useState(initialPasswordInput);

	const initialOrganizationInput = {
		random_id: '',
		name: 'DNA',
		slug: '',
		billing_contact: '',
		billing_email: '',
		billing_address: '',
		billing_city: '',
		billing_state: '',
		billing_zip: '',
		app: process.env.REACT_APP_NAME,
		errorList: [],
		errorStyle: [],
	};
	const [organizationInput, setOrganizationInput] = useState(initialOrganizationInput);

	// Initial call for user list items
	useEffect(() => {

		if (!AuthUtility.isLoggedIn()) {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData()
			navHistory('/');
		}

		if (isMounted) {
			console.log('[Account - useEffect] mounted');

			setViewMode('view_account');
		} else {
			setIsMounted(true);
		}

	}, [isMounted]);

	// USER FUNCTIONS
	const handleOpenUserForm = () => {
		const tempUserInput = {
			first_name: localStorage.getItem('auth_first_name'),
			last_name: localStorage.getItem('auth_last_name'),
			email: localStorage.getItem('auth_email'),
			app: process.env.REACT_APP_NAME,
			errorList: [],
			errorStyle: [],
		};

		setUserInput(tempUserInput);
		setViewMode('save_user');
	};
	function handleCloseUserForm(){
		// Merge backend org with defaults, so errorList & errorStyle exist
		setUserInput({...initialUserInput});
		setViewMode('view_account');
	}
	const handleUserInput = (event) => {
		event.persist();

		setUserInput({ ...userInput, [event.target.name]: event.target.value });

		console.log('User Input: ',event.target.name, event.target.value);

		//remove the target error message no matter the new input, it will be validated on the server
		if (userInput.errorList.hasOwnProperty(event.target.name)) {
			delete userInput.errorList[event.target.name];
			delete userInput.errorStyle[event.target.name];
			$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
	}

	// PASSWORD FUNCTIONS
	const handleOpenPasswordForm = () => {
		const tempPasswordInput = {
			email: localStorage.getItem('auth_email'),
			password: '',
			new_password: '',
			app: process.env.REACT_APP_NAME,
			errorList: [],
			errorStyle: [],
		};

		setPasswordInput(tempPasswordInput);
		setViewMode('change_password');
	};
	function handleClosePasswordForm(){
		// Merge backend org with defaults, so errorList & errorStyle exist
		setPasswordInput({...initialPasswordInput});
		setViewMode('view_account');
	}
	const handlePasswordInput = (event) => {
		event.persist();

		setPasswordInput({ ...passwordInput, [event.target.name]: event.target.value });

		console.log('Password Input: ',event.target.name, event.target.value);

		//remove the target error message no matter the new input, it will be validated on the server
		if (passwordInput.errorList.hasOwnProperty(event.target.name)) {
			delete passwordInput.errorList[event.target.name];
			delete passwordInput.errorStyle[event.target.name];
			$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
	}

	// ORGANIZATION FUNCTIONS
	const handleOpenOrganizationForm = () => {
		const tempOrganizationInput = {
			random_id: localStorage.getItem('org_random_id'),
			name: localStorage.getItem('org_name'),
			slug: localStorage.getItem('org_slug'),
			billing_contact: localStorage.getItem('org_billing_contact'),
			billing_email: localStorage.getItem('org_billing_email'),
			billing_address: localStorage.getItem('org_billing_address'),
			billing_city: localStorage.getItem('org_billing_city'),
			billing_state: localStorage.getItem('org_billing_state'),
			billing_zip: localStorage.getItem('org_billing_zip'),
			app: process.env.REACT_APP_NAME,
			status: '',
			errorList: [],
			errorStyle: [],
		};
		
		setOrganizationInput(tempOrganizationInput);
		setViewMode('save_organization');
	};
	function handleCloseOrganizationForm(){
		// Merge backend org with defaults, so errorList & errorStyle exist
		setOrganizationInput({...initialOrganizationInput});
		setViewMode('view_account');
	}
	const handleOrganizationInput = (event) => {
		event.persist();

		setOrganizationInput({ ...organizationInput, [event.target.name]: event.target.value });

		console.log('Organization Input: ',event.target.name, event.target.value);

		//remove the target error message no matter the new input, it will be validated on the server
		if (organizationInput.errorList.hasOwnProperty(event.target.name)) {
			delete organizationInput.errorList[event.target.name];
			delete organizationInput.errorStyle[event.target.name];
			$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
	}
	
	const handleConfirmToDeleteOrganization = (event) => {
		if (event) event.preventDefault();

		const tempOrganizationInput = {
			random_id: localStorage.getItem('org_random_id'),
			app: process.env.REACT_APP_NAME,
		};
	
		swal({
			title: 'Delete',
			text: 'This will delete organization ' + localStorage.getItem('org_name') + '.',
			icon: "warning",
			buttons: {
				cancel: true,
				confirm: {
					text: "Delete",
					value: true,
				},
			},
			showCancelButton: true,
		}).then((result) => {
			if (result) {
				deleteOrganization(event, { tempOrganizationInput, setOrganizationInput, setViewMode, setIsLoading, navHistory, swal });
			}else{
				setOrganizationInput(initialOrganizationInput);
			}
		});
	};

	return (
		<div className={`body-content bg-fff pt-70l-110m-50s ${authRole === null || authRole === '' ? 'pb-160l-125s' : 'pb-220l-180s'}`}>

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell">
						<div className="horizontal-container justify-left">
							<span className="font-orbitron font-weight-800 font-size-24l-20m-18s letter-spacing-0px uppercase italic">Account</span>

							<span className="align-right">
								<div className="horizontal-container justify-right">
									{isLoading &&
									<span className="pr-10">
										<LoadingSpinner paddingclassName="none" sizeclassName="none" />
									</span>
									}
										<span className="font-orbitron font-weight-800 font-size-18l-16m letter-spacing-0px uppercase italic pr-10">Logout</span>
									<span className="">
										<Link onClick={() => LogoutService({ setIsLoading, navHistory, swal })} className="button icon">
										<img src={logout_icon} alt="logout" />
										</Link>
									</span>
								</div>
							</span>
						</div>
					</div>
				</div>
			</div>

			{viewMode === 'view_account' && (
			<>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ccc p-20l-10s">

					<div className="large-6 medium-6 small-6 cell text-left">
						<div className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic underline">User</div>
					</div>

					<div className="large-6 medium-6 small-6 cell text-right">
						<Link onClick={handleOpenUserForm} className="button icon"><img src={edit_icon} alt="Edit User" /></Link>
					</div>

					<div className="large-12 medium-12 small-12 cell text-left pt-10">
						<table className="unstriped unbordered mb-0">
							<tbody>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Name:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('auth_first_name') + ' ' + localStorage.getItem('auth_last_name')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Email:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('auth_email')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Role:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('auth_role')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Password:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">
									******** 
									<span className="pl-20">
									<Link onClick={handleOpenPasswordForm} className="font-poppins font-size-18l-16m font-weight-400y">Change</Link>
									</span>
								</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px">Paypal Email:</td><td className="font-poppins font-size-18l-16m font-weight-600">{localStorage.getItem('auth_paypal_email')}</td></tr>
							</tbody>
						</table>
					</div>

				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ccc p-20l-10s">

					<div className="large-6 medium-7 small-8 cell text-left">
						<div className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic underline">Collaboration Team</div>
					</div>

					{localStorage.getItem('org_name') && localStorage.getItem('org_name') !== '' ? (
					<div className="large-6 medium-5 small-4 cell text-right">
						<Link onClick={(event) => handleConfirmToDeleteOrganization(event)} className="button icon"><img src={delete_icon} alt="Delete Organization" /></Link>
						<span className="pl-20 right">
						<Link onClick={handleOpenOrganizationForm} className="button icon"><img src={edit_icon} alt="Edit Organization" /></Link>
						</span>
					</div>
					) : (
					<div className="large-6 medium-5 small-4 cell text-right">
						<Link onClick={handleOpenOrganizationForm} className="button icon"><img src={plus_icon_black} alt="Add Organization" /></Link>
					</div>
					)}

					<div className="large-12 medium-12 small-12 cell text-left pt-10">
						<table className="unstriped unbordered mb-0">
							<tbody>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Name:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('org_name')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Billing Contact:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('org_billing_contact')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Billing Email:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-10">{localStorage.getItem('org_billing_email')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Billing Address:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-20">{localStorage.getItem('org_billing_address')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Billing City:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-20">{localStorage.getItem('org_billing_city')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px pb-10">Billing State:</td><td className="font-poppins font-size-18l-16m font-weight-600 pb-2100">{localStorage.getItem('org_billing_state')}</td></tr>
								<tr><td className="font-poppins font-size-18l-16m font-weight-400 width-150px">Billing Zip:</td><td className="font-poppins font-size-18l-16m font-weight-600">{localStorage.getItem('org_billing_zip')}</td></tr>
							</tbody>
						</table>
					</div>

				</div>
			</div>

			</>
			)}

			{viewMode === 'save_user' && (
			<>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bb1-555 pb-5">
					<div className="large-12 medium-12 small-12 cell">
						<span className="font-orbitron font-size-24 font-weight-800 uppercase italic">Profile</span>
					</div>
				</div>
			</div>
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-10 ">
						<form onSubmit={(event) => UserService(event, { userInput, setUserInput, setViewMode, setIsLoading, navHistory, swal })}>
							<div className="grid-x">
								<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
									<div className={userInput.errorStyle.first_name}>{userInput.errorList.first_name}</div>
									<div className="p-5" id="first_name_message">&nbsp;</div>
									<input type="text" name="first_name" onChange={handleUserInput} value={userInput.first_name} placeholder="First Name" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
									<div className={userInput.errorStyle.last_name}>{userInput.errorList.last_name}</div>
									<div className="p-5" id="last_name_message">&nbsp;</div>
									<input type="text" name="last_name" onChange={handleUserInput} value={userInput.last_name} placeholder="Last Name" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pr-5l-0s">
									<div className={userInput.errorStyle.email}>{userInput.errorList.email}</div>
									<div className="p-5" id="email_message">&nbsp;</div>
									<input type="text" name="email" onChange={handleUserInput} value={userInput.email} placeholder="Email" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pl-5l-0s">
								</div>
								<div className="large-6 medium-6 small-6 cell text-left pt-20">
									<button onClick={handleCloseUserForm} className="button width-125px-100px">Cancel</button>
								</div>
								<div className="large-6 medium-6 small-6 cell text-right pt-20">
									<div className="horizontal-container float-right">
										{isLoading &&
											<span className="element pr-10">
												<LoadingSpinner paddingclassName="none" sizeclassName="none" />
											</span>
										}
										<span className="element">
											<button type="submit" className="button width-125px-100px">Submit</button>
										</span>
									</div>
								</div>
							</div>
						</form>
					</div>

				</div>
			</div>
			</>
			)}

			{viewMode === 'change_password' && (
			<>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bb1-555 pb-5">
					<div className="large-12 medium-12 small-12 cell">
						<span className="font-orbitron font-size-24 font-weight-800 uppercase italic">Reset Password</span>
					</div>
				</div>
			</div>
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-10 ">
						<form onSubmit={(event) => PasswordService(event, { passwordInput, setPasswordInput, setViewMode, setIsLoading, navHistory, swal })}>
							<div className="grid-x">
								<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
									<div className={passwordInput.errorStyle.password}>{passwordInput.errorList.password}</div>
									<div className="p-5" id="password_message">&nbsp;</div>
									<input type="password" name="password" onChange={handlePasswordInput} value={passwordInput.password} placeholder="Old Password" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
									<div className={passwordInput.errorStyle.new_password}>{passwordInput.errorList.new_password}</div>
									<div className="p-5" id="new_password_message">&nbsp;</div>
									<input type="password" name="new_password" onChange={handlePasswordInput} value={passwordInput.new_password} placeholder="New Password" />
								</div>
								<div className="large-6 medium-6 small-6 cell text-left pt-20">
									<button onClick={handleClosePasswordForm} className="button width-125px-100px">Cancel</button>
								</div>
								<div className="large-6 medium-6 small-6 cell text-right pt-20">
									<div className="horizontal-container float-right">
										{isLoading &&
											<span className="element pr-10">
												<LoadingSpinner paddingclassName="none" sizeclassName="none" />
											</span>
										}
										<span className="element">
											<button type="submit" className="button width-125px-100px">Submit</button>
										</span>
									</div>
								</div>
							</div>
						</form>
					</div>

				</div>
			</div>
			</>
			)}

			{viewMode === 'save_organization' && (
			<>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bb1-555 pb-5">
					<div className="large-12 medium-12 small-12 cell">
						<span className="font-orbitron font-size-24 font-weight-800 uppercase italic">Organization</span>
					</div>
				</div>
			</div>
			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell bg-fafafa b1-ccc p-10 ">
						<form onSubmit={(event) => saveOrganization(event, { organizationInput, setOrganizationInput, setViewMode, setIsLoading, navHistory, swal })}>
							<div className="grid-x">
								<div className="large-12 medium-12 small-12 cell text-left">
									<div className={organizationInput.errorStyle.name}>{organizationInput.errorList.name}</div>
									<div className="p-5" id="name_message">&nbsp;</div>
									<input type="text" name="name" onChange={handleOrganizationInput} value={organizationInput.name} placeholder="Organization Name" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pr-5l-0s">
									<div className={organizationInput.errorStyle.billing_contact}>{organizationInput.errorList.billing_contact}</div>
									<div className="p-5" id="billing_contact_message">&nbsp;</div>
									<input type="text" name="billing_contact" onChange={handleOrganizationInput} value={organizationInput.billing_contact} placeholder="Billing Contact" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pl-5l-0s">
									<div className={organizationInput.errorStyle.billing_email}>{organizationInput.errorList.billing_email}</div>
									<div className="p-5" id="billing_email_message">&nbsp;</div>
									<input type="text" name="billing_email" onChange={handleOrganizationInput} value={organizationInput.billing_email} placeholder="Billing Email" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pr-5l-0s">
									<div className={organizationInput.errorStyle.billing_address}>{organizationInput.errorList.billing_address}</div>
									<div className="p-5" id="billing_address_message">(optional)</div>
									<input type="text" name="billing_address" onChange={handleOrganizationInput} value={organizationInput.billing_address} placeholder="Billing Adress" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pl-5l-0s">
									<div className={organizationInput.errorStyle.billing_city}>{organizationInput.errorList.billing_city}</div>
									<div className="p-5" id="billing_city_message">(optional)</div>
									<input type="text" name="billing_city" onChange={handleOrganizationInput} value={organizationInput.billingbilling_city_email} placeholder="Billing City" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pr-5l-0s">
									<div className={organizationInput.errorStyle.billing_state}>{organizationInput.errorList.billing_state}</div>
									<div className="p-5" id="billing_state_message">(optional)</div>
									<input type="text" name="billing_state" onChange={handleOrganizationInput} value={organizationInput.billing_state} placeholder="Billing State" />
								</div>
								<div className="large-6 medium-6 small-12 cell text-left pt-10 pl-5l-0s">
									<div className={organizationInput.errorStyle.billing_zip}>{organizationInput.errorList.billing_zip}</div>
									<div className="p-5" id="billing_zip_message">(optional)</div>
									<input type="text" name="billing_zip" onChange={handleOrganizationInput} value={organizationInput.billing_zip} placeholder="Billing Zip" />
								</div>
								<div className="large-6 medium-6 small-6 cell text-left pt-20">
									<button onClick={handleCloseOrganizationForm} className="button width-125px-100px">Cancel</button>
								</div>
								<div className="large-6 medium-6 small-6 cell text-right pt-20">
									<div className="horizontal-container float-right">
										{isLoading &&
											<span className="element pr-10">
												<LoadingSpinner paddingclassName="none" sizeclassName="none" />
											</span>
										}
										<span className="element">
											<button type="submit" className="button width-125px-100px">Submit</button>
										</span>
									</div>
								</div>
							</div>
						</form>
					</div>

				</div>
			</div>
			</>
			)}
		</div>
	);
}

export default Account;